<template>
    <v-row class="fill-height">
        <v-col>
            <v-card
                flat
            >
                <v-card-title>
                    <!--<v-icon @click="pushRouteToView('persons')" class="mr-4" style="cursor: pointer">
                        mdi-arrow-left
                    </v-icon>-->
                    <v-btn
                        small
                        @click="$router.go(-1)"
                        class="mr-4 btn-back"
                    >
                        <v-icon> mdi-arrow-left</v-icon>
                        Voltar
                    </v-btn>
                    <v-icon left>mdi-cash-register</v-icon>
                    Cadastro de Conta
                    <v-spacer></v-spacer>

                    <!--                    <v-btn-->
                    <!--                        class="btn-new"-->
                    <!--                        @click="dialogmovementAccount = true"-->
                    <!--                    >-->
                    <!--                        <v-icon left>mdi-plus</v-icon>-->
                    <!--                        Adicionar-->
                    <!--                    </v-btn>-->
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row>
                        <v-col md="12" sm="12">

                            <v-select
                                :items="accountCategory"
                                v-model="movementAccount.bsAccountCategory"
                                label="Tipo de Conta"
                                item-value="id"
                                item-text="name"
                                outlined
                                dense>
                            </v-select>
                        </v-col>
                    </v-row>

                    <v-form
                        ref="formMovementAccount"
                        v-model="formIsValid"
                        v-on:submit.prevent="submitMovementAccount()"
                        v-show="movementAccount.bsAccountCategory >= 1 && movementAccount.bsAccountCategory <= 3"
                    >

                        <v-row>
                            <v-col sm="12" md="12">

                                <v-text-field
                                    v-model="movementAccount.name"
                                    outlined
                                    label="Nome da Conta"
                                    placeholder="Informe um nome para sua conta"
                                    @blur="movementAccount.name=movementAccount.name.toUpperCase()"
                                    :rules="textRules"
                                    append-icon="mdi-format-align-justify"
                                    dense
                                ></v-text-field>

                            </v-col>
                        </v-row>

                        <v-row
                            v-show="movementAccount.bsAccountCategory == 1 || movementAccount.bsAccountCategory == 2">
                            <v-col sm="12" md="12">
                                <v-autocomplete
                                    v-model="movementAccount.bank"
                                    :items="localBanks"
                                    hide-no-data
                                    label="Informe seu banco"
                                    placeholder="Informe o nome do seu banco"
                                    hint=""
                                    :rules="[bankRulesValid]"
                                    outlined
                                    dense
                                >
                                </v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row
                            v-show="movementAccount.bsAccountCategory == 1 || movementAccount.bsAccountCategory == 2">
                            <v-col cols="6" sm="12" md="6">
                                <v-text-field
                                    v-model="movementAccount.agency"
                                    outlined
                                    label="Agência"
                                    placeholder="Informe sua agência"
                                    v-mask="['####', '####-#', '####-##']"
                                    :rules="[bankRulesValid]"
                                    append-icon="mdi-domain"
                                    dense
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="6">
                                <v-text-field
                                    v-model="movementAccount.bankAccount"
                                    outlined
                                    label="Conta"
                                    placeholder="Digite a sua conta bancária con digito"
                                    :rules="[bankRulesValid]"
                                    hint="Ex: 12345-6, 12345-X, 123456-7"
                                    append-icon="mdi-account-cash"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="6" sm="12" md="6">
                                <number-input
                                    label="Saldo Inicial "
                                    v-model.number="movementAccount.initialBalance"
                                    placeholder="Informe o saldo inicial"
                                    :options="optionsMoney"
                                    append-icon="mdi-currency-usd"
                                    outlined
                                    dense
                                ></number-input>
                            </v-col>

                            <v-col cols="12" sm="12" md="6">
                                <v-text-field
                                    v-model="movementAccount.balanceDate"
                                    outlined
                                    label="Data do Saldo"
                                    v-mask="['##/##/####']"
                                    :rules="dateRuleEmpty"
                                    append-icon="mdi-calendar-range"
                                    required
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row
                            v-show="movementAccount.bsAccountCategory == 1 || movementAccount.bsAccountCategory == 2">
                            <v-col class="mb-0 pb-0"> Ou cadastre a chave do PIX</v-col>
                        </v-row>
                        <v-row
                            v-show="movementAccount.bsAccountCategory == 1 || movementAccount.bsAccountCategory == 2">
                            <v-col sm="12" md="12">
                                <v-radio-group
                                    v-model="movementAccount.chavePIXType"
                                    row
                                    dense
                                    :rules="[pixRulesValid]"
                                    class="mt-0 pt-0"
                                    hide-details
                                >
                                    <v-radio
                                        label="CNPJ"
                                        value="cnpj"
                                    ></v-radio>
                                    <v-radio
                                        label="Celular"
                                        value="phone"
                                    ></v-radio>
                                    <v-radio
                                        label="E-mail"
                                        value="email"
                                    ></v-radio>
                                    <v-radio
                                        label="Chave Aleatória"
                                        value="random_key"
                                    ></v-radio>

                                </v-radio-group>

                                <v-text-field
                                    v-model="movementAccount.chavePIX"
                                    outlined
                                    label="Chave PIX"
                                    placeholder="Digite sua chave do PIX"
                                    :rules="[pixRulesValid]"
                                    append-icon="mdi-key"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col md="12" sm="12" class="text-right">
                                <v-spacer></v-spacer>
                                <v-btn dark class="btn-cancel mr-1" @click="closeMovementAccount()">
                                    <v-icon left>mdi-close</v-icon>
                                    Cancelar
                                </v-btn>
                                <v-btn class="btn-save ml-1" dark type="submit">
                                    <v-icon left>mdi-check</v-icon>
                                    Salvar
                                </v-btn>
                            </v-col>
                        </v-row>

                    </v-form>


                    <v-form
                        ref="formReceiptAccount"
                        v-model="formIsValid"
                        v-on:submit.prevent="submitReceiptAccount()"
                        v-show="movementAccount.bsAccountCategory >= 4 && movementAccount.bsAccountCategory <= 5"
                    >

                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field
                                    v-model="receiptAccount.name"
                                    outlined
                                    label="Nome da Conta"
                                    placeholder="Informe um nome para sua conta"
                                    :rules="textRules"
                                    @blur="receiptAccount.name=receiptAccount.name.toUpperCase()"
                                    append-icon="mdi-format-align-justify"
                                    dense
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <v-select
                                    v-model="receiptAccount.bsAccountMovementID"
                                    :items="movementAccounts"
                                    item-value="id"
                                    item-text="name"
                                    label="Conta de Resgate"
                                    placeholder="Escolha um Serviço"
                                    :rules="textRules"
                                    outlined
                                    dense
                                >
                                </v-select>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col sm="12" md="6">
                                <number-input
                                    label="Taxa "
                                    v-model.number=receiptAccount.fee
                                    placeholder="Informe a tarifa por transação"
                                    :options="optionsCommission"
                                    append-icon="mdi-percent"
                                    outlined
                                    dense
                                ></number-input>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="12">
                                Maquininha
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" sm="12" md="6">
                                <v-radio-group
                                    v-model="receiptAccount.cardMachine"
                                    row
                                    dense
                                    class="mt-0 pt-0"
                                >
                                    <v-radio
                                        label="Própria"
                                        value="own"
                                    ></v-radio>
                                    <v-radio
                                        label="Aluguel"
                                        value="rent"
                                    ></v-radio>
                                    <v-radio
                                        label="Parcelado"
                                        value="installments"
                                    ></v-radio>
                                </v-radio-group>
                            </v-col>

                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4" sm="12"
                                   v-show="receiptAccount.cardMachine === 'rent' || receiptAccount.cardMachine === 'installments'">
                                <number-input
                                    label="Valor"
                                    v-model.number="receiptAccount.valueMachine"
                                    placeholder="Informe o Valor "
                                    :options="optionsMoney"
                                    append-icon="mdi-currency-usd"
                                    :rules="[machineRentRulesValid]"
                                    outlined
                                    dense
                                ></number-input>
                            </v-col>
                            <v-col cols="12" md="4" sm="12"
                                   v-show="receiptAccount.cardMachine === 'rent' || receiptAccount.cardMachine === 'installments'">
                                <v-select
                                    :items="days"
                                    v-model="receiptAccount.dayMachine"
                                    label="Dia de pagamento"
                                    :rules="[machineRentRulesValid]"
                                    outlined
                                    dense>
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="4" sm="12" v-show="receiptAccount.cardMachine === 'installments'">
                                <number-input
                                    label="Parcelas"
                                    v-model.number="receiptAccount.installmentMachine"
                                    placeholder="Informe o número de parcelas "
                                    :rules="[machineInstallmentsRulesValid]"
                                    :options="optionsNum"
                                    append-icon="mdi-numeric"
                                    outlined
                                    dense
                                ></number-input>
                            </v-col>

                        </v-row>

                        <!--                        <v-row v-show="movementAccount.bsAccountCategory == 5">-->
                        <!--                            <v-col cols="12" md="6" sm="12">-->
                        <!--                                <number-input-->
                        <!--                                    label="Taxa por Transação"-->
                        <!--                                    v-model.number="receiptAccount.transactionFee"-->
                        <!--                                    placeholder="Informe a Taxa Por Transação "-->
                        <!--                                    :options="optionsCommission"-->
                        <!--                                    append-icon="mdi-percent"-->
                        <!--                                    outlined-->
                        <!--                                    dense-->
                        <!--                                ></number-input>-->
                        <!--                            </v-col>-->
                        <!--                            <v-col cols="12" md="6" sm="12">-->

                        <!--                                <number-input-->
                        <!--                                    label="Taxa de Parcelamento"-->
                        <!--                                    v-model.number="receiptAccount.installmentFee"-->
                        <!--                                    placeholder="Informe a Taxa de Parcelamento "-->
                        <!--                                    :options="optionsCommission"-->
                        <!--                                    append-icon="mdi-percent"-->
                        <!--                                    :rules="[receiptAccountRules]"-->
                        <!--                                    outlined-->
                        <!--                                    dense-->
                        <!--                                ></number-input>-->
                        <!--                            </v-col>-->
                        <!--                        </v-row>-->

                        <v-row>
                            <v-col cols="12" sm="12">
                                Ciclo de Recebimento
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row v-show="movementAccount.bsAccountCategory == 5">
                            <v-col sm="12" md="12">
                                <v-radio-group
                                    v-model="receiptAccount.cardCycle"
                                    row
                                    dense
                                    class="mt-0 pt-0"
                                >
                                    <v-radio
                                        label="Ciclo dinâmico"
                                        value="dynamic"
                                    ></v-radio>
                                    <v-radio
                                        label="Ciclo Fixo"
                                        value="fixed"
                                    ></v-radio>

                                </v-radio-group>
                            </v-col>
                        </v-row>


                        <v-row v-show="movementAccount.bsAccountCategory == 5">
                            <v-col cols="12" md="6" sm="12" v-show="receiptAccount.cardCycle === 'dynamic'">
                                <v-select
                                    :items="days"
                                    v-model="receiptAccount.rescueDay"
                                    label="D + N"
                                    placeholder="Dia do Resgate"
                                    :rules="[cardDynamicRules]"
                                    outlined
                                    dense>
                                </v-select>
                            </v-col>


                            <v-col cols="12" md="6" sm="12" v-show="receiptAccount.cardCycle === 'fixed'">
                                <v-select
                                    :items="days"
                                    v-model="receiptAccount.closingDay"
                                    label="Dia de Fechamento"
                                    :rules="[cardFixedRules]"
                                    outlined
                                    dense>
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="6" sm="12" v-show="receiptAccount.cardCycle === 'fixed'">
                                <v-select
                                    :items="days"
                                    v-model="receiptAccount.receiptDay"
                                    label="Dia de Recebimento"
                                    :rules="[cardFixedRules]"
                                    outlined
                                    dense>
                                </v-select>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col md="12" sm="12" class="text-right">
                                <v-spacer></v-spacer>
                                <v-btn dark class="btn-cancel mr-1" @click="closeReceiptAccount()">
                                    <v-icon left>mdi-close</v-icon>
                                    Cancelar
                                </v-btn>
                                <v-btn class="btn-save ml-1" dark type="submit">
                                    <v-icon left>mdi-check</v-icon>
                                    Salvar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>

                </v-card-text>
            </v-card>
        </v-col>

    </v-row>
</template>

<script>
import {mask} from "vue-the-mask";
import {mapGetters} from "vuex";
// import store from "@/store";
import NumberInput from "@/components/NumberInput";

import {CHANGE_PROGRESS} from "@/store/mutations/mutations.type";

import {
    MOVEMENT_ACCOUNT_CREATE, MOVEMENT_ACCOUNTS_GET, RECEIPT_ACCOUNT_CREATE
} from "@/store/actions/financial.type";
import {banks} from "@/common/banks.list";

const patternDate = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]|(?:Jan|Mar|May|Jul|Aug|Oct|Dec)))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2]|(?:Jan|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec))\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)(?:0?2|(?:Feb))\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9]|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep))|(?:1[0-2]|(?:Oct|Nov|Dec)))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/

export default {
    name: "financial",
    directives: {mask},
    components: {NumberInput},
    data: () => ({
        textRules: [
            (v) => !!v || "Este campo é obrigatório",
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],

        myPlan: {
            day: 10,
            value: 89.90,

        },

        selected: [],
        options: {},
        headers: [
            {text: "Data", align: "left", value: "date"},
            {text: "Valor", value: "value"},
            {text: "Status", value: "status"},
            // {text: "Valor Total", value: "totalValue"},
            // {text: "Usuário", value: "username"},
            {text: "Documento", value: "actions", sortable: false}
        ],
        tab: null,


        data: [
            {id: 1, date: '2022-02-09', value: 89.90, status: 'Aguardando Pagamento'},
            {id: 2, date: '2022-01-10', value: 89.90, status: 'Pago'},
            {id: 3, date: '2021-12-11', value: 89.90, status: 'Pago'},
            {id: 4, date: '2021-11-07', value: 89.90, status: 'Pago'},
            {id: 5, date: '2021-10-10', value: 89.90, status: 'Pago'},
            {id: 6, date: '2021-09-08', value: 89.90, status: 'Pago'},
        ],

        days: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],

        localBanks: [],
        search: null,
        balanceRequestValue: 0,
        balanceRequest: {
            value: 0,
            valueReleased: 0,
            valueToReleased: 0,
            valueTotal: 0,
            valueRate: 0,
            bankID: 0
        },

        formIsValid: false,
        optionsNum: {
            locale: "pt-BR",
            prefix: "",
            length: 2,
            precision: 0,
        },
        optionsMoney: {
            locale: "pt-BR",
            prefix: "R$:",
            length: 9,
            precision: 2
        },
        optionsCommission: {
            locale: "pt-BR",
            prefix: "",
            length: 4,
            precision: 2,
        },
        active: false,
        btnBalanceCheck: true,

        dialogRescueBalance: false,
        dialogBalance: false,
        dialogmovementAccount: false,


        dialogBankRemove: false,
        socialEdit: false,
        updateLogo: null,


        social: {
            socialID: 0,
            url: "",
        },

        balance: {
            socialID: 0,
            url: "",
        },
        subtitle: {
            socialID: 0,
            url: "",
        },

        pixRules: [
            v => !!v && !!this.movementAccount.bank && this.movementAccount.agency && this.movementAccount.account || "Este campo é obrigatório"
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],
        dateRule: [
            date => {
                // if (!date) return true;
                return patternDate.test(date) || "Informe uma data válida."
            }
        ],
        dateRuleEmpty: [
            date => {
                if (!date) return true;
                return patternDate.test(date) || "Informe uma data válida."
            }
        ],
    }),

    methods: {
        querySelections(v) {
            this.localBanks = banks.filter((e) => {
                return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
            });
        },
        async submitMovementAccount() {
            if (this.$refs.formMovementAccount.validate()) {
                this.$store.commit(CHANGE_PROGRESS, true);

                await this.$store
                    .dispatch(MOVEMENT_ACCOUNT_CREATE, this.movementAccount)
                    .then(async () => {
                        this.$store.commit(CHANGE_PROGRESS, false);

                        this.snackbar.snackbar = true;
                        this.snackbar.color = "success";
                        this.snackbar.text = "Salvo com sucesso";

                        this.$refs.formMovementAccount.resetValidation();
                        this.$refs.formMovementAccount.reset();

                        this.$router.push({name: 'financialAccounts'});
                    })
                    .catch(({response}) => {
                        this.$store.commit(CHANGE_PROGRESS, false);
                        this.dialogmovementAccount = false;
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "error";
                        this.snackbar.text = "Erro ao salvar dados bancários";
                        if (typeof response.data.message !== "undefined") {
                            this.snackbar.text =
                                "Erro ao salvar dados bancários: " + response.data.message;
                        }
                    });
            } else {
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Preencha o formulário corretamente";
            }
        },

        async submitReceiptAccount() {
            if (this.$refs.formReceiptAccount.validate()) {
                this.$store.commit(CHANGE_PROGRESS, true);

                await this.$store
                    .dispatch(RECEIPT_ACCOUNT_CREATE, this.receiptAccount)
                    .then(async () => {
                        this.$store.commit(CHANGE_PROGRESS, false);

                        this.snackbar.snackbar = true;
                        this.snackbar.color = "success";
                        this.snackbar.text = "Salvo com sucesso";

                        this.$refs.formMovementAccount.resetValidation();
                        this.$refs.formMovementAccount.reset();

                        this.$router.push({name: 'financialAccounts'});
                    })
                    .catch(({response}) => {
                        this.$store.commit(CHANGE_PROGRESS, false);
                        this.dialogmovementAccount = false;
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "error";
                        this.snackbar.text = "Erro ao salvar dados bancários";
                        if (typeof response.data.message !== "undefined") {
                            this.snackbar.text =
                                "Erro ao salvar dados bancários: " + response.data.message;
                        }
                    });
            } else {
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Preencha o formulário corretamente";
            }
        },


        rescueRules(v) {
            let n = parseFloat(v.replace(".", "").replace(",", "."))
            if (isNaN(n)) return "Informe um valor válido ";

            if (n < 1) return "O Valor Mínimo é de R$ 1,00";

            if (this.finance.balanceTotal < n) return "O Valor informado é maior que o Saldo Total";

            return true
        },
        bankRulesValid(v) {
            if (!this.movementAccount.chavePIX && (this.movementAccount.bsAccountCategory === 2 || this.movementAccount.bsAccountCategory === 1)) {
                return !!v || "Este campo é obrigatório"
            }
            return true
        },
        pixRulesValid(v) {
            if (!this.movementAccount.bank && !this.movementAccount.agency && !this.movementAccount.account && (this.movementAccount.bsAccountCategory === 2 || this.movementAccount.bsAccountCategory === 1)) {
                return !!v || "Este campo é obrigatório"
            }
            return true
        },
        machineRentRulesValid(v) {
            if (this.receiptAccount.cardMachine === "rent" || this.receiptAccount.cardMachine === "installments") {
                return !!v || "Este campo é obrigatório"
            }
            return true
        },
        machineInstallmentsRulesValid(v) {
            if (this.receiptAccount.cardMachine === "installments") {
                return !!v || "Este campo é obrigatório"
            }
            return true
        },
        receiptAccountRules(v) {
            if (this.movementAccount.bsAccountCategory === 5) {
                return !!v || "Este campo é obrigatório"
            }
            return true
        },
        cardDynamicRules(v) {

            if (this.receiptAccount.cardCycle === 'dynamic') {
                return !!v || "Este campo é obrigatório"
            }
            return true
        },
        cardFixedRules(v) {
            if (this.receiptAccount.cardCycle === 'fixed') {
                return !!v || "Este campo é obrigatório"
            }
            return true
        },
        installmentRules(v) {
            if (this.receiptAccount.installment === true) {
                return !!v || "Este campo é obrigatório"
            }
            return true
        },
        freeFeeRules(v) {
            if (this.receiptAccount.freeFee === true) {
                return !!v || "Este campo é obrigatório"
            }
            return true
        },


        //Dialog Bank Account - Botão Adicionar (Conta)
        closeMovementAccount() {
            this.$refs.formMovementAccount.resetValidation();
            this.$refs.formMovementAccount.reset();
            this.$router.push({name: 'financialAccounts'});
        },
        closeReceiptAccount() {
            this.$refs.formReceiptAccount.resetValidation();
            this.$refs.formReceiptAccount.reset();
            this.$router.push({name: 'financialAccounts'});
        },


    },
    async mounted() {
        this.localBanks = banks
        if (this.movementAccounts.length === 0) {
            await this.$store.dispatch(MOVEMENT_ACCOUNTS_GET);
        }
    },
    watch: {
        search(val) {
            console.log(this.select)
            console.log(val, val && val !== this.select && this.querySelections(val))
            val && val !== this.select && this.querySelections(val)
        },

        options: {
            handler() {
                this.buscar()
            },
            deep: true,
        },
    },
    computed: {
        ...
            mapGetters(["snackbar", "finances", "financePagination", "movementAccount", "receiptAccount", "accountCategory", "movementAccounts"]),
    }
    ,
};
</script>